import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import * as auth2 from "../../app/modules/Auth/_redux/authRedux";
import restlessUsersReducer from "./RestlessUserReducer";
import { usersSlice } from "../actions/users/usersSlice";
import { verificationSlice } from "../actions/verification/verificationSlice";
import { postsSlice } from "../actions/posts/postsSlice";
import { imageAuthSlice } from "../actions/imageAuth/imageAuthSlice";
import { hashtagsSlice } from "../actions/hashtags/hashtagsSlice";
import { articlesSlice } from "../actions/artciles/articlesSlice";
import { commentsSlice } from "../actions/comments/commentsSlice";
import { authSlice } from "../actions/auth/authSlice";
import { analyticsSlice } from "../actions/analytics/analyticsSlice";
import { notificationsSlice } from "../actions/notifications/notificationsSlice";
import { mediaSlice } from "../actions/media/mediaSlice";
import { reportsSlice } from "../actions/reports/reportsSlice";

export const rootReducer = combineReducers({
  auth2: auth2.reducer,
  auth: authSlice.reducer,
  users: restlessUsersReducer,
  users2: usersSlice.reducer,
  verification: verificationSlice.reducer,
  posts: postsSlice.reducer,
  imageAuth: imageAuthSlice.reducer,
  hashtags: hashtagsSlice.reducer,
  articles: articlesSlice.reducer,
  comments: commentsSlice.reducer,
  analytics: analyticsSlice.reducer,
  notifications: notificationsSlice.reducer,
  media: mediaSlice.reducer,
  reports: reportsSlice.reducer
});

export function* rootSaga() {
  yield all([auth2.saga()]);
}
